import React, { useCallback } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

// Components
import { Button } from '@beef/ui-kit';
import { PeriodSelection } from '../PeriodSelection';
import { DETALIZATION_CALENDAR } from '../../../../constants/detalization';
import { DATE_DROPDOWN, DATE_PERIOD } from '../mock';
import { setStartPeriod, setEndPeriod } from '../../store/periodSelection/actions';
import {
  setDetalizationReportEndPeriod,
  setDetalizationReportStartPeriod,
} from '../../store/detalizationReport/actions';
import { fetchExpenses } from '../../store/expensesData/action';
import { fetchPayments } from '../../store/paymentsData/action';
import { fetchExpensesPrepaid } from '../../store/expensesPrepaidData/action';

// Styles
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const UpdateByDate = ({ aggregateType }) => {
  const dispatch = useDispatch();
  const {
    startPeriod,
    endPeriod,
    isValidPeriod,
    activeTabs,
  } = useSelector(({ detalizationNew }) => ({
    startPeriod: detalizationNew.periodSelection.startPeriod,
    endPeriod: detalizationNew.periodSelection.endPeriod,
    isValidPeriod: detalizationNew.periodSelection.isDataValid,
    activeTabs: detalizationNew.expenses.activeTabs,
  }), shallowEqual);

  const onChangeStartDate = useCallback(
    (startDate) => {
      dispatch(setDetalizationReportStartPeriod(startDate));
      dispatch(setStartPeriod(startDate));
    },
    [dispatch, startPeriod],
  );

  const onChangeEndDate = useCallback(
    (endDate) => {
      dispatch(setDetalizationReportEndPeriod(endDate));
      dispatch(setEndPeriod(endDate));
    },
    [dispatch, endPeriod],
  );

  const onSetSelectedDateOption = useCallback(
    (entry) => {
      onChangeStartDate(DATE_PERIOD[entry]);
      onChangeEndDate(new Date());
    },
    [onChangeStartDate, onChangeEndDate],
  );

  const handleMakeReport = useCallback(() => {
    if (aggregateType) {
      dispatch(fetchExpensesPrepaid(aggregateType));
      dispatch(fetchExpenses());
      return;
    }

    if (activeTabs === 'replenish') {
      dispatch(fetchPayments());
    } else {
      dispatch(fetchExpenses());
    }
  }, [aggregateType, activeTabs]);

  return (
    <div className={cx('container')}>
      <div className={cx('calendar', { 'calendar--error': !isValidPeriod })}>
        <PeriodSelection
          title={DETALIZATION_CALENDAR.CALENDAR_TITLE}
          errorMessage={DETALIZATION_CALENDAR.ERROR_PERIOD_MESSAGE}
          setStartPeriod={onChangeStartDate}
          setEndPeriod={onChangeEndDate}
          startPeriod={startPeriod}
          endPeriod={endPeriod}
          setPeriod={onSetSelectedDateOption}
          isValidPeriod={isValidPeriod}
          dropdown={DATE_DROPDOWN}
        />
      </div>
      <Button
        size="xs"
        variant="secondary"
        disabled={!isValidPeriod}
        onClick={handleMakeReport}
      >
        Составить отчёт
      </Button>
    </div>
  );
};

UpdateByDate.propTypes = {
  aggregateType: PropTypes.array,
};

export default UpdateByDate;
